<template lang="pug">
.global-navigation
    .global-navigation__menu.flex.items-center(v-if="menus.length > 0 || moreMenu.length > 0 || (auth_data.role && auth_data.role.label && (auth_data.role.label === 'superadmin' || auth_data.role.label === 'admin'))")
        ul
            template(v-if="menus.length > 0")
                li(v-for="menu in menus" :key="menu.name")
                    router-link.btn-header(:to='menu.url' @click.native="closedLayer()" v-bind:class="routePath == menu.url?'btn-menu-active':''") {{ menu.name}}

            li.relative.menu-more(v-if="moreMenu.length > 0 || (auth_data.role && auth_data.role.label && (auth_data.role.label === 'superadmin' || auth_data.role.label === 'admin'))")
                button.btn-header.btn-flex(
                    ref="buttonMoreIsActive"
                    v-on:click=" moreIsActive = !moreIsActive;"
                    v-bind:class="{'btn-menu-active': moreIsActive || moreChildActive}"
                    )
                    span Other
                    //- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class=""><polyline points="6 9 12 15 18 9"></polyline></svg>
                    template(v-if="moreIsActive")
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class=""><polyline points="18 15 12 9 6 15"></polyline></svg>
                    template(v-else)
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class=""><polyline points="6 9 12 15 18 9"></polyline></svg>
                .box-submenu.absolute(
                    v-bind:class="{'box-submenu--show' : moreIsActive}"
                    v-closable="{exclude: ['buttonMoreIsActive'], handler: 'onCloseBtnMoreIsActive'}"
                )
                    .box-submenu__body
                        ul.flex-col.items-start.text-left
                            li.w-full(v-for="submenu in moreMenu" :key="submenu.name")
                                router-link.block.p-2(
                                    class="hover:bg-gray-800"
                                    :to='submenu.url'
                                    @click.native="onCloseBtnMoreIsActive(); closedLayer(); toggleSidebar()"
                                ) {{ submenu.name}}
                            
                            li.w-full
                                router-link.block.p-2(
                                    to="/license"
                                    class="hover:bg-gray-800"
                                    ) License

                            template(v-if="auth_data.role && auth_data.role.label && (auth_data.role.label === 'superadmin' || auth_data.role.label === 'admin')")
                                li.w-full(v-if="auth_data.role.label === 'superadmin'")
                                    router-link.block.p-2(
                                        class="hover:bg-gray-800"
                                        to="/upload-app"
                                        @click.native="onCloseBtnMoreIsActive(); closedLayer(); toggleSidebar()"
                                    ) Upload App

                                li.w-full
                                    router-link.block.p-2(
                                        class="hover:bg-gray-800"
                                        to="/users-log"
                                        @click.native="onCloseBtnMoreIsActive(); closedLayer(); toggleSidebar()"
                                    ) Users Log

                                li.w-full.mt-3(v-if="isAstro !== 'true' || (isAstro === 'true' && auth_data.role.label === 'superadmin')")
                                    button.btn-primary-o.w-full(v-if="download_app.file_name && download_app.file" @click="downloadApp()")
                                        | DOWNLOAD {{ download_app.file_name }}

                                    button.btn-primary-o.w-full(v-else @click="onCloseBtnMoreIsActive(); closedLayer()")
                                        | NO APP AVAILABLE
        //- for update foto
        router-link.btn-primary-o.upload-media(v-if="isAstro !== 'true' && show_upload_media === true" to="/media")
            | Upload media

        router-link.btn-primary-o.upload-media.ml-2(v-if="isAstro !== 'true' && show_face_recognition === true" to="/face-recognition")
            | Face Recognition
        
        router-link(v-if="show_notification === true" to="/notification").btn-header.flex.items-center.justify-center
            .icon-notif.relative
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 5.33331C12 4.27245 11.5786 3.25503 10.8284 2.50489C10.0783 1.75474 9.06087 1.33331 8 1.33331C6.93913 1.33331 5.92172 1.75474 5.17157 2.50489C4.42143 3.25503 4 4.27245 4 5.33331C4 9.99998 2 11.3333 2 11.3333H14C14 11.3333 12 9.99998 12 5.33331Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.15333 14C9.03612 14.2021 8.86789 14.3698 8.66548 14.4864C8.46307 14.6029 8.23358 14.6643 8 14.6643C7.76641 14.6643 7.53692 14.6029 7.33451 14.4864C7.1321 14.3698 6.96387 14.2021 6.84666 14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                .bubble.absolute.rounded-full.px-1.flex.items-center.justify-center.bg-red-300(v-if="notification_count_all > 0")
                    span.text-bold.text-red-800 {{ notification_count_all }}
                    
    .global-navigation__account.relative
        button.btn-header.btn-flex(
                ref="buttonAccount"
                v-on:click="toggleActive = !toggleActive"
                v-bind:class="{toggleActive : toggleActive || accountChildActive}"
            )
            figure.avatar
                //- img(src="https://randomuser.me/api/portraits/men/9.jpg")
                img(:src="auth_data!==null && auth_data.photo ? auth_data.photo : getDefaultImage" @error="getDefaultImage")
            template(v-if="toggleActive")
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class=""><polyline points="18 15 12 9 6 15"></polyline></svg>
            template(v-else)
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class=""><polyline points="6 9 12 15 18 9"></polyline></svg>
        .box-submenu.absolute(
                v-bind:class="{'box-submenu--show' : toggleActive}"
                v-closable="{exclude: ['buttonAccount'], handler: 'onCloseBtnAccount'}"
            )
            .box-submenu__header
                router-link.full-width(to="/profile" @click.native="onCloseBtnAccount(); closedLayer(); toggleSidebar()")
                    strong.block {{ auth_data!==null && auth_data.name ? auth_data.name : '' }}
                    span {{ auth_data!==null && auth_data.email ? auth_data.email : '' }}
            .box-submenu__body(v-if="accountMenus.length > 0")
                ul
                    li(v-for="menu in accountMenus" :key="menu.name")
                        router-link.block.p-2(
                            :to='menu.path'
                            @click.native="onCloseBtnAccount(); onCloseBtnMoreIsActive(); closedLayer(); toggleSidebar()"
                        )
                            //- span(v-if="menu.icon" v-html="menu.icon")
                            | {{ menu.name }}

            .box-submenu__footer
                button.block.btn-logout( @click="onCloseBtnAccount(); handleLogout();") Logout
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';
import axios from 'axios';

// account event button
let handleOutsideClick
Vue.directive('closable', {
    bind (el, binding, vnode) {
        // Here's the click/touchstart handler
        // (it is registered below)
        handleOutsideClick = (e) => {
            e.stopPropagation()
            // Get the handler method name and the exclude array
            // from the object used in v-closable
            const { handler, exclude } = binding.value

            // This variable indicates if the clicked element is excluded
            let clickedOnExcludedEl = false
            exclude.forEach(refName => {
                // We only run this code if we haven't detected
                // any excluded element yet
                if (!clickedOnExcludedEl) {
                    // Get the element using the reference name
                    const excludedEl = vnode.context.$refs[refName];
                    // See if this excluded element
                    // is the same element the user just clicked on
                    if (excludedEl)
                    clickedOnExcludedEl = excludedEl.contains(e.target);
                }
            })

            // We check to see if the clicked element is not
            // the dialog element and not excluded
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                // If the clicked element is outside the dialog
                // and not the button, then call the outside-click handler
                // from the same component this directive is used in
                vnode.context[handler]()
            }
        }
        // Register click/touchstart event listeners on the whole page
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
    },

    unbind () {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
    }
})

export default {
    name: 'shellGlobalMenu',
    data: function () {
        return {
            toggleActive: false,
            moreIsActive: false,
            moreChildActive: false,
            accountChildActive: false,
            // defaultImage: this.$store.getters.getDefaultImage,
            defaultImage: require('../../../assets/images/default-avatar.png'),

            isAstro: process.env.VUE_APP_ASTRO,

            notification_count_all: 0,

            routePath: null,

            is_use_fr: (process.env.VUE_APP_FACE_RECOGNITION && process.env.VUE_APP_FACE_RECOGNITION.toLowerCase() === 'false' ? false : true),
            is_use_fr_old: (process.env.VUE_APP_FR_OLD && process.env.VUE_APP_FR_OLD.toLowerCase() === 'true' ? true : false),
            show_upload_media: false,
            show_face_recognition: false,

            show_notification: false,
        };
    },
    computed: {
        ...mapState([
            'auth_data',
            'notification_count',
            'download_app',
        ]),
        menus() {
            let menus = [
                // {
                //     name: 'Home',
                //     url: '/'
                // },
            ];

            if (this.auth_data.role && (this.auth_data.role.label === 'superadmin' || (this.auth_data.role.module && this.auth_data.role.module.length > 0))) {
                // case management
                let check_case_management = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'case_management';
                });
                if (check_case_management.length > 0 || this.auth_data.role.label === 'superadmin')
                    menus.push({
                        name: 'Case Management',
                        url: '/case-management'
                    });
                    
                // target
                let check_target = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'single_target';
                });
                if (check_target.length > 0 || this.auth_data.role.label === 'superadmin')
                    menus.push({
                        name: 'Target',
                        url: '/target'
                    });

                // multi tracking
                let check_multi_tracking = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'multi_target';
                });
                if (check_multi_tracking.length > 0 || this.auth_data.role.label === 'superadmin')
                    menus.push({
                        name: 'Multi Tracking',
                        url: '/multi-tracking'
                    });

                // territory virtual
                let check_territory_virtual = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'territory_virtual';
                });
                if (check_territory_virtual.length > 0 || this.auth_data.role.label === 'superadmin')
                    menus.push({
                        name: 'Territory Virtual',
                        url: '/territory-virtual'
                    });

                if (this.isAstro === 'true') {

                    // tactical devices
                    // let check_tactical_devices = this.auth_data.role.module.filter(function(item) {
                    //     return item.label === 'tactical_device';
                    // });
                    if (this.auth_data.role.label === 'superadmin')
                        menus.push({
                            name: 'Tactical Devices',
                            url: '/tactical-devices'
                        });
                }

                if (this.isAstro !== 'true' && this.is_use_fr) {

                    if (this.is_use_fr_old) {
                        // upload media
                        let check_upload_media = this.auth_data.role.module.filter(function(item) {
                            return item.label === 'mendagri' || item.label === 'aiservice';
                        });
                        if (check_upload_media.length > 0 || this.auth_data.role.label === 'superadmin') 
                            this.show_upload_media = true; // eslint-disable-line
                    
                    } else {
                        // note
                        // face_recognition
                        // if (this.auth_data.role.label === 'superadmin')
                        if (this.checkFeatureByAcl(this.auth_data, 'face_recognition', null))
                            this.show_face_recognition = true; // eslint-disable-line
                    }

                }                

                // notification
                let check_notification = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'notification';
                });
                if (check_notification.length > 0 || this.auth_data.role.label === 'superadmin')
                    this.show_notification = true; // eslint-disable-line
            }

            return menus;
        },
        moreMenu() {

            let moreMenu = [
                // {
                //     name: 'Components',
                //     url: '/components'
                // },
            ];

            if (this.auth_data.role && (this.auth_data.role.label === 'superadmin' || (this.auth_data.role.module && this.auth_data.role.module.length > 0))) {

                // monitoring log
                let check_monitoring_log = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'log_activity';
                });
                if (check_monitoring_log.length > 0 || this.auth_data.role.label === 'superadmin')
                    moreMenu.push({
                        name: 'Monitoring Log',
                        url: '/monitoring'
                    });

                // tracking history
                let check_tracking_history = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'tracking_target';
                });
                if (check_tracking_history.length > 0 || this.auth_data.role.label === 'superadmin')
                    moreMenu.push({
                        name: 'Tracking History',
                        url: '/tracking-history'
                    });

                // result
                // if (this.isAstro !== 'true') {
                //     moreMenu.push({
                //         name: 'Result',
                //         url: '/result/recent-location'
                //     });
                //     // moreMenu.push({
                //     //     name: 'Components',
                //     //     url: '/components'
                //     // });
                // }
            }

            // let moreMenu = [

            //     {
            //         name: 'Monitoring Log',
            //         url: '/monitoring'
            //     },

            //     {
            //         name: 'Tracking History',
            //         url: '/tracking-history'
            //     },
            //     {
            //         name: 'Result',
            //         url: '/result/recent-location'
            //     },
            //     // {
            //     //     name: 'Components',
            //     //     url: '/components'
            //     // },
            // ];

            // // for astro, remove result & component
            // if (this.isAstro === 'true') {
            //     // moreMenu.splice(2, 1);
            //     moreMenu.splice(2, 1);
            //     // moreMenu.splice(1, 1);
            //     // moreMenu.splice(1, 1);
            // }

            return moreMenu;
        },
        accountMenus() {

            let accountMenus = [];

            if (this.auth_data.role && (this.auth_data.role.label === 'superadmin' || (this.auth_data.role.module && this.auth_data.role.module.length > 0))) {

                // clients
                if (this.isAstro !== 'true') {
                    let check_clients = this.auth_data.role.module.filter(function(item) {
                        return item.label === 'client';
                    });
                    if (check_clients.length > 0 || this.auth_data.role.label === 'superadmin')
                        accountMenus.push({
                            name: 'Clients',
                            path: '/clients',
                        });
                }

                // modules
                let check_modules = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'module';
                });
                if (check_modules.length > 0 || this.auth_data.role.label === 'superadmin')
                    accountMenus.push({
                        name: 'Modules',
                        path: '/modules',
                    });

                // function modules
                let check_function = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'function';
                });
                if (check_function.length > 0 || this.auth_data.role.label === 'superadmin')
                    accountMenus.push({
                        name: 'Function',
                        path: '/function',
                    });

                // acl
                let check_acl = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'acl';
                });
                if (check_acl.length > 0 || this.auth_data.role.label === 'superadmin')
                    accountMenus.push({
                        name: 'ACL',
                        path: '/acl',
                    });

                // roles
                let check_roles = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'role';
                });
                if (check_roles.length > 0 || this.auth_data.role.label === 'superadmin')
                    accountMenus.push({
                        name: 'Roles',
                        path: '/roles',
                    });

                // users
                let check_users = this.auth_data.role.module.filter(function(item) {
                    return item.label === 'user';
                });
                if (check_users.length > 0 || this.auth_data.role.label === 'superadmin')
                    accountMenus.push({
                        name: 'Users',
                        path: '/users',
                    });
            }

            // let accountMenus = [
            //     {
            //         name: 'Clients',
            //         path: '/clients',
            //     },
            //     {
            //         name: 'Roles',
            //         path: '/roles',
            //     },
            //     {
            //         name: 'Users',
            //         path: '/users',
            //     },
            //     {
            //         name: 'ACL',
            //         path: '/acl',
            //     },
            //     // {
            //     //     name: 'Roles Access',
            //     //     path: '/roles-access',
            //     // },
            //     // {
            //     //     name: 'Modules',
            //     //     path: '/modules',
            //     // },
            // ];

            // // for astro, remove clients
            // if (this.isAstro === 'true') {
            //     accountMenus.splice(0, 1);
            // }

            return accountMenus;
        },
        route_name(){
            return this.$route.name
        },
    },
    watch: {
        menus() {},
        moreMenu() {},
        accountMenus() {},
        notification_count(newData) {
            this.setNotificationCount(newData);
        },
        route_name(){
            this.routePath = '/'+window.location.href.split('/')[3]
            this.checkMoreChild()
            this.checkAccountChild()
        },
    },
    methods: {
        getDefaultImage(e) {
            e.target.src = this.defaultImage;
        },
        onCloseBtnAccount() {
            this.toggleActive = false;
        },
        onCloseBtnMoreIsActive() {
            this.moreIsActive = false;
        },
        closedLayer() {
            EventEmit.$emit('mobileMenuClose')
        },
        async downloadApp() {
            this.showLoading(true);

            // let self = this;
            // setTimeout(function() {
            //     self.showLoading(false);
            // }, 3000);
            await this.$store.dispatch('getDownloadApp');

            await axios.get(this.download_app.file, { responseType: 'blob' })
            .then(response => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', this.download_app.file_name +'.apk');
                document.body.appendChild(fileLink);

                fileLink.click();

                this.$swal.fire({
                    title: 'Download success!',
                    icon: 'success',
                    text: this.download_app.file_name +'.apk has been downloaded.',
                    // timer: 3000,
                });
            })
            .catch((response) => {
                console.log(response);

                this.$swal.fire({
                    title: 'Failed download file!',
                    icon: 'error',
                    text: 'Something wrong.',
                    // timer: 3000,
                });

            });

            this.onCloseBtnMoreIsActive(); 
            this.closedLayer();
        },
        setNotificationCount(data=[]) {
            if (data.length === 0)
                data = this.notification_count;

            if (data.length > 0) {
                data = data.filter(function(item) {
                    return item.type === 'all';
                });

                // console.log(data[0].count);
                if (data.length > 0) {
                    this.notification_count_all = data[0].count;
                } else {
                    this.notification_count_all = 0;
                }
            } else {
                this.notification_count_all = 0;
            }
        },
        handleLogout() {

            // loading
            // this.$swal.fire({
            //     title: '',
            //     html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
            //     showConfirmButton: false,
            //     allowOutsideClick: false
            // });

            this.showLoading(true);

            // -------------------------------------------------------------

            if (process.env.VUE_APP_AUTH_TYPE === 'local') {

                // with local auth
                // localStorage.removeItem('local_auth_token');
                // localStorage.removeItem('auth_token');
                // localStorage.removeItem('auth_data');

                this.$store.commit('setAuthToken', null);
                this.$store.commit('setAuthData', null);

                this.$router.push({ name: 'pageLogin' });
                this.$swal.close();

            } else if (process.env.VUE_APP_AUTH_TYPE === 'api') {

                // with auth api
                this.$store.dispatch('getLogout').then((resp) => {

                    // console.log('after logout request in Logout.vue');
                    // console.log(resp);

                    if (resp.result === 'success') {
                        
                        // localStorage.removeItem('auth_token');
                        // localStorage.removeItem('auth_data');
                        this.$router.push({ name: 'pageLogin' });

                        this.$swal.close();
                    } else {
                        this.$swal.fire({
                            title: 'Failed logout!',
                            icon: 'error',
                            text: (resp.data && resp.data.message ? resp.data.message : 'Something wrong.'),
                            // timer: 3000,
                        });
                    }
                });
            } else {
                this.$swal.fire({
                    title: 'Failed logout!',
                    icon: 'error',
                    text: 'There is no auth type configuration in .env.',
                    // timer: 3000,
                });
            }

        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        checkMoreChild(){
            // console.log('masuk checkmore')
            var check= this.moreMenu.filter(p => p.url == this.routePath)
            // console.log(check.length)
            if(check.length>0){
                this.moreChildActive = true
            } else {
                this.moreChildActive = false
            }
        },
        checkAccountChild(){
            // console.log('masuk checkAcc')
            var check= this.accountMenus.filter(p => p.path == this.routePath)
            // console.log(check.length)
            if(check.length>0){
                this.accountChildActive = true
            } else {
                this.accountChildActive = false
            }
        },
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
    },
    events: {
        closeEvent: function () {
            // console.log('close event called')
            this.hide();
        }
    },
    async mounted() {
        // console.log(this.account)

        // console.log(this.auth_data.role.module)
        // if (this.auth_data.role && this.auth_data.role.module && this.auth_data.role.module.length > 0) {

        //     let notification = [];
        //     notification = this.auth_data.role.module.filter(function(item) {
        //       return item.label === 'territory_virtual';
        //       // if (item.label === 'notification')
        //       //   return item;
        //     });
        //     // console.log(notification[0].label)
        //     console.log(notification.length)
        // }

        if (this.$route.name !== 'PageNotification') {
            await this.$store.dispatch('getNotificationCount');
            this.setNotificationCount();
        }

        if (this.auth_data.role && this.auth_data.role.label && (this.auth_data.role.label === 'superadmin' || this.auth_data.role.label === 'admin') && this.$route.name !== 'PageUploadApp')
            this.$store.dispatch('getDownloadApp');
        
        this.routePath = '/'+window.location.href.split('/')[3]
        this.checkMoreChild()
        this.checkAccountChild()
    },
}
</script>

